/**
 * 小程序相关接口
 * @authors kanglimei
 * @date    2018/8/1
 * @version v1.0
 */
import env from '../../build/env'

let api = {}
api.url = env === 'development'
  ? 'https://www.torinosrc.com/cicadas/apis' // 本地测试地址
  : env === 'production'
    ? 'https://www.torinosrc.com/cicadas/apis' // 生产环境地址
    : 'https://www.torinosrc.com/cicadas/apis' // 出错后默认地址

// 获取小程序分类
api.miniapptypes = '/api/v1/miniapptypes'

// 获取小程序列表
api.miniapps = '/api/v1/miniapps'

// 查找小程序
api.miniapps = '/api/v1/miniapps'

// 获取小程序详情
api.miniapps = '/api/v1/miniapps'

api.weixin = {}

api.weixin.signature = '/api/v1/weixin/signature'

export default api



// WEBPACK FOOTER //
// ./src/libs/homesite-api.js